<template>
  <div class="radio-list" :class="`radio-list--${layout}`">
    <div v-for="(option, i) of data.options" :key="option.value" class="radio-option" :class="{'checked': isChecked(option)}">
      <label class="radio-label" :for="option.value">
        <input
          :id="option.value"
          type="checkbox"
          :name="option.value"
          :checked="isChecked(option)"
          @change="handleCheck(i, $event)"
        >
        <span :style="checkboxBackground" class="checkmark" />
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>

import isEqual from 'lodash/isEqual'

export default {
  name: 'RadioList',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: { // Answer
      type: Object,
      required: true
    },
    checkboxImage: {
      type: String,
      default: 'tick.svg'
    },
    showRadioCheckIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    checkboxBackground () {
      const url = this.showRadioCheckIcon ? require(`@/assets/icons/${this.checkboxImage}`) : ''
      return { '--checkbox-background': `url(${url})` }
    },
    layout () {
      return this.data.layout
    }
  },
  methods: {
    handleCheck (i, e) {
      let selected = this.data.options[i]
      this.$emit('input', { result: selected })
    },
    isChecked (option) {
      return this.value && isEqual(this.value.result, option)
    }
  }
}
</script>

<style scoped lang="scss">
.radio-list {
  display: flex;
  flex-direction: column;
  align-items: center;

  .radio-option {
    border-radius: $radiolist-border-radius;
    background-color: $white;
    width: 100%;
    margin: $spacing-12 $spacing-0;
    font-size: 20px;
    line-height: 20px;
    box-shadow: $radiolist-shadow;
    border: $radiolist-border;
    transition: 0.25s all;
    color: $radiolist-color;
    position: relative;
    top: 0;

    @media (max-width: $screen_md) {
      margin: 0 0 $spacing-16 0;
    }

    &:hover {
      background-color: $radiolist-hover-bg;
      border: $radiolist-border-hover;
      box-shadow: $radiolist-shadow-hover;
      top: -4px;
    }

    &.checked {
      border: $radiolist-border-selected;
      background-color: $radiolist-selected-bg;
      color: $radiolist-selected-text;
      box-shadow: $radiolist-shadow-selected;
      top: -4px;
    }

    .radio-label {
      margin: $spacing-0;
      width: 100%;
      padding: $spacing-16;
      padding-left: $spacing-24;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      text-align: left;
      cursor: pointer;

      @media (max-width: $screen_md) {
        padding: $spacing-12;
      }
    }

    input[type=checkbox] {
      display: none;
    }

    .checkmark {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      margin-right: $spacing-12;
      border: $radiolist-checkbox-border;
      background-color: $white;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: $screen_md) {
        width: 22px;
        height: 22px;
      }
    }

    &.checked {
      .checkmark {
        background-image: var(--checkbox-background);
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: $radiolist-checkbox-bg-selected;
        border: $radiolist-checkbox-border-selected;
        box-shadow: $radiolist-checkbox-box-shadow-selected;
      }
    }
  }

  @media (min-width: $screen-md + 1) {
    &--grid {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex-direction: row;

      .radio-option {
        width: calc(50% - #{$spacing-12});
        margin-bottom: $spacing-12;

        &.clear {
          width: 100%;
        }
      }
    }
  }

}
</style>
